"use client" 
import Select from "react-select"
// import dynamic from "next/dynamic";
// const Select = dynamic(() => import("react-select"), {
//   ssr: false,
// });
import makeAnimated from 'react-select/animated'

import { useState, useEffect } from "react"
// import divisions from "../../../json/sectors"
import useSelectStyles from "./Styles"


const currencies = [
  { id: 1, value: "USD", label: "USD" },
  { id: 2, value: "CAD", label: "CAD" },
  { id: 3, value: "EUR", label: "EUR" },
  { id: 4, value: "GBP", label: "GBP" },
  { id: 5, value: "AUD", label: "AUD" },
  { id: 6, value: "CHF", label: "CHF" },
  { id: 7, value: "JPY", label: "JPY" },
  { id: 8, value: "CNY", label: "CNY" },
  { id: 9, value: "INR", label: "INR" },
  { id: 10, value: "NZD", label: "NZD" },
  { id: 11, value: "SEK", label: "SEK" },
  { id: 12, value: "NOK", label: "NOK" },
  { id: 13, value: "DKK", label: "DKK" },
  { id: 14, value: "SGD", label: "SGD" },
  { id: 15, value: "HKD", label: "HKD" },
  { id: 16, value: "ZAR", label: "ZAR" },
  { id: 17, value: "BRL", label: "BRL" }
];


const CurrencySelect = ({onChange, defaultValue={"id": 1, "label": "USD", "value": "USD"}, placeholder, id, name, target, callback, lang, required, missingRequired, parent, parentField, userCountryCode}) => {

    //  console.log('usercountrycode', userCountryCode)


    const  userCountryToCurrencyMap = {
          'CA' :  { id: 2, value: "CAD", label: "CAD" },
          'US' :  { id: 1, value: "USD", label: "USD" },
          'GB' :  { id: 4, value: "GBP", label: "GBP" },
          'AU' :   { id: 5, value: "AUD", label: "AUD" },
     }

    //  console.log("TARGET", target)
     const animatedComponents = makeAnimated();


     const [isClient, setIsClient] = useState(false)
     const [data, setData] = useState(null);
     const [loading, setLoading] = useState(true);
     const [error, setError] = useState(null);
     const [isClearable, setIsClearable] = useState(true);
     const [isSearchable, setIsSearchable] = useState(true);
     const [isDisabled, setIsDisabled] = useState(false);
     const [isLoading, setIsLoading] = useState(false);
     const [isRtl, setIsRtl] = useState(false);
     const [selectedSector, setSelectedSector] = useState(null)

     const handleChange = async (x) => {
      setSelectedSector(x)
      callback(x)
      onChange()
     }
     

     useEffect(() => {
       setIsClient(true)
     }, [])
     
    //  divisions.concat([{"id": 0, "value": "CROSS_DIVISION", "label_en": "Cross-Division", "label_fr": "Inter-Division"}]);
 
if (!isClient) {
     return null
}



     return (
          <>
          {/* {console.log("TRGT", target?.[`${parent.toLowerCase()}_sector_industry`]?.value)} */}
          
          <Select
          required={required}
            // className={`w-full ${missingRequired && 'border border-red-400 dark:border-red-600'} dark:bg-inherit rounded-lg appearance-none px-0 text-gray-700 leading-tight focus:outline-none focus:shadow-outline place-items-start`}

            className={`w-full px-0 ${missingRequired && 'border border-red-400 dark:border-red-600 rounded-xl'} dark:bg-inherit appearance-none inner-shadow rounded text-gray-700 leading-tight focus:outline-none focus:shadow-outline`}



            classNamePrefix="select"
          //   defaultValue={colourOptions[0]}
            isDisabled={isDisabled}
            isLoading={isLoading}
            isClearable={isClearable}
            isRtl={isRtl}
            isSearchable={isSearchable}
            name={name}
            id={id}
          
            onChange={handleChange}
            // value={selectedSector || target && {value: target?.[`${parent.toLowerCase()}_sector_industry`]?.value, label: target?.[`${parent.toLowerCase()}_sector_industry`]?.[`label_${lang}`]} || null}
            value={selectedSector || target && {value: target?.[parentField]?.value, label: target?.[parentField]?.[`label`]} || userCountryToCurrencyMap[userCountryCode] || defaultValue}
            options={
currencies.map(x => {return {id: x.id, value: x.value, label: x.label}})
            }
            components={animatedComponents}
            placeholder={placeholder}
            styles={useSelectStyles()}
          />
    

        </>
     
     )
}

export default CurrencySelect